export const QUERIES_TO_REFETCH_AFTER_EMAIL_UPDATE = [
    'GetEmailStats',
    'GetEmailSyncStatusBanner',
    'GetNutshellMarketingOnboardingChecklist',
] as const;
